export const constants = {
  User: {
    MEMBER: 'Member',
    FILTPOD: 'FILT Pod',
    HOOTSUITE: 'Hootsuite',
    CHROMEEXTENSION: 'Chrome Extension',
    PROMINENCEGLOBAL: 'Prominence Global',
    AFFILIATEPARTNER: 'Affiliate Partner',
    GROWTHPLAN : 'Growth Plan',
    ENGAGEAI: 'Member',
    KYNZO: 'Member',
  },
  EXTENSION_ID: 'cbaogfgokhicbaeafmcieddcnikkkhio'
};

// External links, kept in one place so a help-centre or affiliate move is a one-line change.
export const LINKS = {
  HELP_CENTER: 'https://kynzo.hiverkb.com/',
  AFFILIATE: 'https://kynzo.io/affiliate/',
  CHROME_EXTENSION: 'https://kynzo.io/',
  SUPERBOOST_CALENDAR: 'https://calendly.com/filt-pod/book-superboost-for-your-linkedin-post',
};

